import * as firebase from "firebase/app"
import "firebase/firestore"
import "firebase/functions"
import "firebase/auth"

import { log } from "./Logging"

declare const FIREBASE_PROD: boolean

export interface FirebaseDoc {
    id?: string
}

log.debug("Initializing firebase.")
const FIREBASE_ENVIRONMENT = FIREBASE_PROD ? "prodConfig" : "devConfig"

interface FirebaseOptions {
    name: string
    apiKey: string
    authDomain: string
    databaseURL: string
    projectId: string
    storageBucket: string
    messagingSenderId: string
    appId: string
}

const makeConfig = (
    name: string,
    messagingSenderId: string,
    apiKey: string,
    appId: string,
): FirebaseOptions => ({
    name,
    apiKey,
    authDomain: `clickcity-${name}.firebaseapp.com`,
    databaseURL: `https://clickcity-${name}.firebaseio.com`,
    projectId: `clickcity-${name}`,
    storageBucket: `clickcity-${name}.appspot.com`,
    messagingSenderId,
    appId,
})
const prodConfig = makeConfig(
    "e627c",
    "933932724595",
    "AIzaSyC721S24vrt4zZA0eP1HsCvFWePdEZANE8",
    "1:933932724595:web:86577db05efc2c5a",
)
const demoConfig = makeConfig(
    "demo",
    "734622171603",
    "AIzaSyBt1s3wUntu0fuYvuZnkv8VIbnyYJpmJys",
    "1:734622171603:web:61d5c6d30bae08cd",
)
const devConfig = makeConfig(
    "dev",
    "802193738758",
    "AIzaSyAt48EOYJhk4UffhK3Ows74AuGAEeD0g-g",
    "1:802193738758:web:b2585aae1e0f36eb",
)

export let fireBaseOptionsInUse: FirebaseOptions

const initializeEnv = (options: FirebaseOptions) => {
    log.debug(`Firebase using: ${options.name} env`)
    fireBaseOptionsInUse = options
    firebase.initializeApp(options)
}

/* tslint:disable-next-line */
initializeEnv(eval(FIREBASE_ENVIRONMENT))

export const fbdb = firebase.firestore()

export const studentCollection = () => fbdb.collection("student")
export const studentResultsCollection = () => fbdb.collection("student-results")
export const activityProgressCollection = () =>
    fbdb.collection("all-activity-progress")
export const classCollection = () => fbdb.collection("class")
export const portalUserCollection = () => fbdb.collection("portal-user")

export const fbFunctions = () => firebase.functions()
export const fbAuth = () => firebase.auth()

export type FBTimestamp = firebase.firestore.Timestamp
export const FBTimestampNow = () => firebase.firestore.Timestamp.now()

export type QuerySnapshot = firebase.firestore.QuerySnapshot
export type QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot

export class FbUtils {
    static queryToDocs = (queryDocs: QuerySnapshot): Array<FirebaseDoc> => {
        if (queryDocs.empty) {
            return []
        }
        return queryDocs.docs.map((result) => FbUtils.queryDocToDoc(result))
    }

    static queryToSingleDoc = (queryDocs: QuerySnapshot): FirebaseDoc => {
        if (queryDocs.empty) {
            return undefined
        }
        if (queryDocs.docs.length > 1) {
            throw new Error(
                `More than one result. ids: ${queryDocs.docs.map(
                    (result) => result.id,
                )}`,
            )
        }
        return FbUtils.queryDocToDoc(queryDocs.docs[0])
    }

    static queryDocToDoc = (queryDoc: QueryDocumentSnapshot): FirebaseDoc => {
        const id = queryDoc.id
        const doc = queryDoc.data()
        return {
            id,
            ...doc,
        }
    }
}
